export default __webpack_public_path__ + "static/media/sample-demo-icon.4bf6d5c8.svg";